import FileTypeIcon from 'pages/MyFiles/FileTypeIcon';

import styles from '../Results.module.scss';
import { ReviewContent } from '../types';
import DeletePage from './DeletePage';

interface Props {
  onClick: (obj: ReviewContent) => void;
  active: boolean;
  item: ReviewContent;
}

const PrintThumbnail = ({ item, onClick, active }: Props) => {
  return (
    <div
      className={`${styles.reviewContent} ${styles.thumb} ${active && styles.active}`}
      onClick={() => onClick(item)}
    >
      <div dangerouslySetInnerHTML={{ __html: item.review }} />
      <p className={styles.thumbTitle}>
        <FileTypeIcon type="pdf" />
        <span title={item.name}>{item.name}</span>
        <DeletePage />
      </p>
    </div>
  );
};

export default PrintThumbnail;
